import { render, staticRenderFns } from "./roleform.vue?vue&type=template&id=0ef1e95a&scoped=true"
import script from "./roleform.vue?vue&type=script&lang=js"
export * from "./roleform.vue?vue&type=script&lang=js"
import style0 from "./roleform.vue?vue&type=style&index=0&id=0ef1e95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef1e95a",
  null
  
)

export default component.exports